import { useTheme } from "@/hooks/useTheme";
import { Stack } from "expo-router";

export default function SupervisingLayout() {
  const { colors } = useTheme();
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: {
          backgroundColor: colors.background,
        },
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="[shift]" />
    </Stack>
  );
}
